<script>
  import { setContext } from 'svelte';
  import VenueLogo from 'components/header/VenueLogo.svelte';
  import LandscapeUIToggle from 'components/a11y/LandscapeUIToggle.svelte';
  import InfoSnippets from './InfoSnippets.svelte';

  export let app;
  setContext('app', app);
</script>

<div id="right-sidebar">
  <VenueLogo />
  <div class="filler"></div>
  <div class="controls">
    <LandscapeUIToggle />
  </div>
  <InfoSnippets/>
</div>

<style media="screen">
  .filler {
    flex-grow: 2;
  }
  .controls {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin: 16px 16px 96px;
    color: var(--headerColor, white);
  }

  :global(.landscape) #right-sidebar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: start;
    flex-direction: column;
    order: 3;
    height: 100%;
    width: 15%;
    background: var(--rightSidebar--bg);
  }
</style>
